import { render, staticRenderFns } from "./NotificationsListView.vue?vue&type=template&id=0c93ef34"
import script from "./NotificationsListView.vue?vue&type=script&lang=js"
export * from "./NotificationsListView.vue?vue&type=script&lang=js"
import style0 from "./NotificationsListView.vue?vue&type=style&index=0&id=0c93ef34&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports